module.exports = __webpack_public_path__ + "img/news-icon.730a97a7.png";